import React from 'react';
import PropTypes from 'prop-types';

import contractPage from 'hoc/contractPage/contractPage';

import ContractTemplate from '../patterns/ContractTemplate/ContractTemplate';

export function PrivacyPolicy({ pageContent }) {
  return (
    <ContractTemplate title="Política de Privacidade do Nubank">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: pageContent }} />
    </ContractTemplate>
  );
}

PrivacyPolicy.propTypes = {
  pageContent: PropTypes.string.isRequired,
};

export default contractPage(PrivacyPolicy, {
  routeKey: 'PRIVACY_POLICY_CONTRACT',
  googleDocumentId: '1JusaMswMPRm9vXaUhWjdExU2-AZR0ITIrq-rALEPrAM',
});
